import {connect} from 'react-redux';
import {denormalize} from 'normalizr';

import {schema} from '../../../../../state/schema';
import {loadResourceCategories, deleteResourceCategory} from '../../../../../state/modules/resourceCategories/actions';
import {sendMessage} from '../../../../../state/actions';
import ResourceCategoriesList from '../components/ResourceCategoriesList';

const mapStateToProps = (state, ownProps) => {

  const page = ownProps.page;
  const limit = ownProps.limit;
  const order = ownProps.order;
  const result = state.resourceCategories.getIn(['pages', order, limit, page]);

  return {
    list: result 
      ? result.map(x => {
          return {
            key: x,
            ...denormalize(
              state.entities.getIn(['resourceCategories', x]),
              schema.resourceCategory,
              state.entities.toJS()
            )
          };
        }).toArray()
      : [],
    isLoading: state.resourceCategories.get('isLoading'),
    total: state.resourceCategories.get('total'),
  }
}

const mapDispatchToProps = dispatch => {
  return {
    load: (page, limit, order, filter, cb) => {
      dispatch(loadResourceCategories(page, limit, order, filter, cb));
    },
    remove: (id, cb) => {
      dispatch(deleteResourceCategory(id, cb));
    },
    sendMessage: (level, title, body, expires) => {
      dispatch(sendMessage(level, title, body, expires));
    },
  }
}

const ResourceCategoriesListContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ResourceCategoriesList);

export default ResourceCategoriesListContainer;